export default "__VITE_ASSET__BzjASTBm__"